import React, { useId, useState } from "react";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import { SiteFormField } from "../UI/SiteFormField";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import { addReportTemplate } from "../../utils/reportTemplatesStorage";

export function SaveReportTemplateButton({ tab, getFieldsSnapshot }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const titleId = useId();

  const close = () => {
    setOpen(false);
    setName("");
  };

  const onSave = () => {
    const fields = getFieldsSnapshot?.();
    if (!fields) {
      return;
    }
    const saved = addReportTemplate({
      name,
      tab,
      fields,
    });
    if (saved) {
      close();
    }
  };

  return (
    <>
      <BtnPrimaryv4 text="Сохранить" onClick={() => setOpen(true)} />
      {open ? (
        <SideDrawer
          title="Сохранить шаблон отчёта"
          titleId={titleId}
          onClose={close}
          usePortal={false}
          toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
          footer={
            <>
              <BtnPrimaryv4 text="Сохранить" onClick={onSave} footerSize />
              <BtnOutlineV4 text="Отмена" onClick={close} />
            </>
          }
        >
          <div className="site-modal-body">
            <SiteFormField label="Название шаблона" full>
              <input
                className="site-form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Например: Подписки 25 дней, мои"
                autoFocus
              />
            </SiteFormField>
          </div>
        </SideDrawer>
      ) : null}
    </>
  );
}
